import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Col } from 'react-bootstrap';
import { Input, Checkbox, Select } from 'formsy-react-components';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import styled from 'styled-components'
import Parse from 'parse'

/* Imports for Image Upload Field */
import Dropzone from 'react-dropzone'
import { DoubleBounce } from 'better-react-spinkit'
import { DropzoneDiv } from '../../../internal/BlackboardBlog/BlackboardStyle'
import axios from 'axios'
import config from 'react-global-configuration';

@inject('adminStore', 'utilStore')
@observer
class CompanyInputs extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imageUploading: false,
            imageUploaded: false,
            selectedCountry: undefined,
        }
        this.uploadWidget = this.uploadWidget.bind(this)
        this.onDrop = this.onDrop.bind(this)

        this.getDefaultFee()
    }

    componentWillMount() {
      this.props.adminStore.getRoles()
    }

    uploadWidget(file) {
      let formData = new FormData()

      formData.append('file', file[0])
      formData.append("tags", `theloge, blog`)
      formData.append("upload_preset", config.get("CLOUDINARY_PRESET"))
      formData.append("timestamp", (Date.now() / 1000) | 0)

      axios.post(config.get("CLOUDINARY_UPLOAD_URL"), formData, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      }).then(response => {
        this.props.onChange({
          companyImage: response.data.public_id,
        })
        this.setState({
          imageUploaded: true,
          imageUploading: false
        })
      }).catch(err => {
        console.error("err", err)
      })
    }

    onDrop(acceptedFiles) {
      this.setState({
        imageUploading: true,
        image: acceptedFiles[0]
      });
      this.uploadWidget(acceptedFiles)
      // this.updateStates()
    }

    componentDidUpdate(prevProps) {
    	if (prevProps.partner !== this.props.partner) {
        this.getDefaultFee();
      }

  	}

    getDefaultFee = () => {
      const current_date = new Date()
      Parse.Config.get().then(obj => {
        this.props.onChange({contract: { fee: obj.get("YEARLY_FEE"), year: current_date.getMonth() > 9 ? current_date.getFullYear()+1 : current_date.getFullYear() }})
      });

      // selected right country

      // const { regions } = this.props.utilStore

      // const selectedRegion = this.props.data && regions.find( item => item == this.props.data.region )
      // console.log(selectedRegion, this.props.data.region);

      this.setState({ selectedCountry: this.props.data && this.props.data.region && this.props.data.region.country && this.props.data.region.country.slug })
    }

    render() {


        const { regions, countries } = this.props.utilStore
        const { roles } = this.props.adminStore
        const partner = this.props.data
        const contract = this.props.contract
        const filteredregions = this.state.selectedCountry ? regions.filter(item => item.country.get("slug") === this.state.selectedCountry) : regions

        const date = new Date()
        const year = date.getFullYear()

        const dateOptions = [
          {
            value: year,
            label: year,
          },
          {
            value: year+1,
            label: year+1,
          }
        ]

        const loadingSpinner = (
          <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 180,
              marginLeft: 30
          }}>
              <DoubleBounce color={"#DAB777"} size={60} />
          </div>
        )

        return (
          <div className={'dashboard-form'}>
              <Col md={12}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 20
                }}>
                  <Dropzone
                    id="dropzone"
                    multiple={false}
                    accept="image/*"
                    onDrop={this.onDrop}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: 180,
                      borderRadius: 5,
                      flex: 1,
                    }}
                  >
                    {
                      this.state.imageUploading ? loadingSpinner : this.state.imageUploaded ? null : <DropzoneDiv
                        size={64}
                        image={`${config.get('CLOUDINARY_URL')}${partner.logo || "default-logo_gzpkqk"}.jpg`}
                        style={{ margin: '0 0 0 30px', width: 180, height: '100%' }}
                      />
                    }
                    {
                      this.state.imageUploading ? null : this.state.imageUploaded ? <DropzoneDiv
                        size={128}
                        image={this.state.image.preview}
                        style={{ margin: '0 0 0 30px', width: 180, height: '100%' }}
                      /> : ''
                    }
                    <p style={{
                      color: 'black',
                      margin: '0px 40px 0px 40px',
                      cursor: 'pointer'
                    }}>
                      Klicken um ein Bild hochzuladen
                    </p>
                  </Dropzone>
                </div>
              </Col>
              <Col md={12}>
                <SectionHeading>Firmeninformationen</SectionHeading>
              </Col>
              <Col md={6}>
                  <Input
                      name="name"
                      label="Firmenname"
                      value={partner.name}
                      type="text"
                      required={this.props.requiredFields.includes("name")}
                      onChange={(name, value) => {
                        this.props.onChange({ partner: { ...partner, name: value, shortname: value.toLowerCase().replace(/[&\/\\#,+()$~%.'":*?!<>{}]/g,'').replace(/ /g, "") } })
                      }}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="uidNumber"
                      label="UID-Nummer"
                      value={partner.uidNumber}
                      type="text"
                      required={this.props.requiredFields.includes("uidNumber")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, uidNumber: value } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="website"
                      label="Website"
                      value={partner.website}
                      type="text"
                      required={this.props.requiredFields.includes("website")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, website: value } })}
                  />
              </Col>

              {/* <Col md={6}>
                  <Input
                      name="vat"
                      label="Steuersatz"
                      value={partner.vat ? partner.vat * 100 : partner.vat != 0 ? 20 : 0}
                      type="number"
                      required={this.props.requiredFields.includes("vat")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, vat: value / 100 } })}
                      addonAfter={"%"}
                  />
              </Col> */}


              <Col md={12}>
                <SectionHeading>Kontakt</SectionHeading>
              </Col>


              <Col md={6}>
                  <Input
                      name="contactEmail"
                      label="Kontakt E-Mail (für Rechnungen, Verträge usw.)"
                      value={partner.contactEmail}
                      type="text"
                      required={this.props.requiredFields.includes("contactEmail")}
                      validations="isEmail"
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, contactEmail: value } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="phone"
                      label="Telefonnummer"
                      value={partner.phone}
                      type="text"
                      required={this.props.requiredFields.includes("phone")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, phone: value } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="email"
                      label="Unternehmens E-Mail (die öffentliche E-Mail Adresse des Unternehmens"
                      value={partner.email}
                      type="email"
                      validations="isEmail"
                      required={this.props.requiredFields.includes("email")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, email: value } })}
                  />
              </Col>

              <Col md={12}>
                <SectionHeading>Anschrift</SectionHeading>
              </Col>


              {/* <Col md={6}>
                  <Input
                      name="billingAddress"
                      label="Rechnungsadresse"
                      value={partner.billingAddress}
                      type="text"
                      required={this.props.requiredFields.includes("billingAddress")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, billingAddress: value } })}
                  />
              </Col> */}
              <Col md={6}>
                  <Input
                      name="street"
                      label="Straße"
                      value={partner.street}
                      type="text"
                      required={this.props.requiredFields.includes("street")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, street: value } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="postcode"
                      label="Postleitzahl"
                      value={partner.postcode}
                      type="number"
                      placeholder=""
                      required={this.props.requiredFields.includes("postcode")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, postcode: Number(value) } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="location"
                      label="Standort"
                      value={partner.location}
                      type="text"
                      required={this.props.requiredFields.includes("location")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, location: value } })}
                  />
              </Col>
              <Col md={6}>
                <Select
                  name="country"
                  label="Land"
                  value={this.state.selectedCountry}
                  options={[ {value: undefined, label: "Land auswählen..."}, ...countries.map( item => { return { value: item.slug, label: item.title }} )]}
                  onChange={(name, value) => this.setState({ selectedCountry: value })}
                />
              </Col>
              <Col md={6}>
                <Select
                  name="region"
                  label="Region"
                  value={partner.region && partner.region.slug}
                  options={[{value: undefined, label: "Region auswählen..."}, ...filteredregions.map( item => { return { value: item.slug, label: item.title }} )]}
                  onChange={(name, value) => this.props.onChange({ partner: { ...partner, region: regions.find(item => item.slug == value) } })}
                />
              </Col>


              <Col md={12}>
                <SectionHeading>Credits</SectionHeading>
              </Col>

              <Col md={6}>
                  <Input
                      name="coins"
                      label="Jährliche Credits"
                      value={partner.coins}
                      type="number"
                      step="1"
                      min="0"
                      required={this.props.requiredFields.includes("coins")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, coins: Number(value) } })}
                  />
              </Col>
              { console.log( roles, partner.role, roles.find(item => item.name === partner.role) ) }
              { !( partner.role && !roles.find(item => item.name === partner.role)) && // do not display the field if we have a "special role"
                <Col md={6}>
                  <Select
                    name="membership"
                    label="Mitlgiedschaft"
                    value={partner.role}
                    options={[ {value: undefined, label: "Mitgliedschaft wählen..."}, ...roles.map( item => ({ value: item.name, label: item.name }) )]}
                    onChange={(name, value) => this.props.onChange({ partner: { ...partner, role: value } })}
                  />
                </Col>
              }
              {/* <Col md={6}>
                  <Input
                      name="maxRemainingStockBookingCount"
                      label="Maximal jährliche Restplatzbuchungen"
                      value={partner.maxRemainingStockBookingCount}
                      type="number"
                      step="1"
                      min="0"
                      required={this.props.requiredFields.includes("maxRemainingStockBookingCount")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, maxRemainingStockBookingCount: Number(value) } })}
                  />
              </Col> */}


              <Col md={12}>
                <SectionHeading>Internes</SectionHeading>
              </Col>

              <Col md={6} style={{padding: "0 35px"}}>
                  <Checkbox
                      value={!partner.isHidden}
                      name="isHidden"
                      label="Sichtbar auf der Partner-Seite?"
                      required={this.props.requiredFields.includes("isHidden")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, isHidden: !value } })}
                  />
              </Col>
              <Col md={6} style={{padding: "0 35px"}}>
                  <Checkbox
                      value={partner.isExternal}
                      name="isExternal"
                      label="Sichtbar auf der Home-Seite?"
                      required={this.props.requiredFields.includes("isExternal")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, isExternal: value } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="sortingNumber"
                      label="Mitgliedsnummer"
                      value={partner.sortingNumber ? partner.sortingNumber : 0}
                      type="number"
                      min="0"
                      required={this.props.requiredFields.includes("sortingNumber")}
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, sortingNumber: Number(value) } })}
                  />
              </Col>
              <Col md={6}>
                  <Input
                      name="shortname"
                      label="Pfad (the-loge.com/company/beispiel-pfad)"
                      // value={partner.shortname ? partner.shortname : partner.name ? partner.name.toLowerCase().replace(/ /g, "") : " "}
                      value={partner.shortname}
                      type="text"
                      required={this.props.requiredFields.includes("shortname")}
                      onChange={(name, value) => {
                        this.props.onChange({ partner: { ...partner, shortname: value.toLowerCase().replace(/ /g, "") } })
                      }}
                  />
              </Col>
              {
                  !partner.objectId &&
                  <Col md={6}>
                      <Select
                          name="contract_year"
                          label="Vertragsjahr"
                          value={contract.year}
                          options={dateOptions}
                          required
                          onChange={(name, value) => this.props.onChange({ contract: { ...contract, year: Number(value) } })}
                      />
                  </Col>
              }
              {
                  !partner.objectId &&
                  <Col md={6}>
                      <Input
                          name="fee"
                          label="Jahresbeitrag"
                          value={contract.fee}
                          type="number"
                          required
                          onChange={(name, value) => this.props.onChange({ contract: { ...contract, fee: Number(value) } })}
                          addonAfter={"€"}
                      />
                  </Col>
              }
              { partner.objectId &&
                <Col md={6} style={{padding: "0 35px"}}>
                  <Checkbox
                      value={partner.autoRenew !== false ? true : false}
                      name="autoRenew"
                      label="Automatische Vertragsverlängerung"
                      onChange={(name, value) => this.props.onChange({ partner: { ...partner, autoRenew: value } })}
                  />
                </Col>
              }

              { ((!partner.objectId && contract.fee !== 0) || partner.objectId) &&
              <Col md={6} style={{padding: "0 35px"}}>
                <Checkbox
                    value={partner.isSpecial !== true ? false : true}
                    name="isSpecial"
                    label="Manuelle Rechnungs- & Vertragsfreigabe"
                    onChange={(name, value) => this.props.onChange({ partner: { ...partner, isSpecial: value } })}
                />
              </Col>
              }
              { partner.objectId &&
                <Col md={6}>
                    <Input
                        disabled
                        name="objectId"
                        label="Object ID"
                        value={partner.objectId}
                        type="text"
                    />
                </Col>
              }
          </div>
        );
    }
}

const SectionHeading = styled.div `
  font-size: 20px;
  margin: 65px 25px 20px 25px;
  padding-bottom: 5px;
  padding-left: 15px;
  color: #212D3D;
	display: block;
  border-bottom: 1px solid #212D3D;
	font-family: "Lora";
`

CompanyInputs.propTypes = {
    userStore: MobxPropTypes.observableObject,
    cookies: instanceOf(Cookies).isRequired
};

export default withCookies(CompanyInputs);



// WEBPACK FOOTER //
// /src/components/admin/Forms/Inputs/CompanyInputs.js